import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.user.user,
    props.user.deposit_bonus,
    props.user.kyc_profile,
    props.vip20.level,
    props.vip20.level_preset,
    props.vip20.xp,
    (user, deposit_bonus, kyc_profile, level, level_preset, xp) => {
        return {
            user,
            deposit_bonus,
            kyc_profile,

            level,
            level_progress: level_preset ? (xp / (level_preset.xp.to + 1)) : 0
        }
    }
)